/*export const environment = {
   production: true,
   api_url: 'https://api.face2faces.fr/api',
   server_url: 'https://api.face2faces.fr',
   app_url: 'https://app.face2faces.com',
   URL : 'https://api.face2faces.fr/api',
   SERVER_URL : 'https://socket.face2faces.fr/'
 };*/

export const environment = {
  production: true,
  api_url: 'https://api-dev.face2faces.com/api',
  server_url: 'https://api-dev.face2faces.com',
  app_url: 'https://app-dev.face2faces.com/',
  URL : 'https://api-dev.face2faces.com/api',
  SERVER_URL : 'https://socket-dev.face2faces.com/'
};
